import { BASE_URL_PROD } from '../../../components/config/keys';
import React,{ useState,useEffect } from "react";
import { useTranslation } from 'react-i18next';
import getTranslation from '../../../utils/getTranslation';
import './styles.scss';
import { Container, Row, Col, Form, Button,Nav,ListGroup,ListGroupItem,Card,Table,Modal,CloseButton} from "react-bootstrap";

import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getWalette} from "../../../actions/user";
import { SET_CURRENT_COMMANDE} from "../../../constants/actions";
import "react-datepicker/dist/react-datepicker.css";
import { BiMap,BiShoppingBag,BiUserCircle,BiHistory,BiBell,BiLock } from 'react-icons/bi';
import { defaultimg } from "../../../assets/images";
import { Menu } from "../../../components";
import moment from 'moment'
import Accordion from 'react-bootstrap/Accordion'
import Switch from '@material-ui/core/Switch';
import { apiClient } from "../../../actions/api"
import { SET_FORMULE_UPDATE} from "../../../constants/actions";


const Page = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const { user } = useSelector(state => state.user)
    const { walette } = useSelector(state => state.restaurent)
    const [startDate, setStartDate] = useState(new Date());
    const [filtres,setFiltres]=useState([]);
    const [order, setOrder] = useState('')
    const [rubrique, setRubrique] = useState(1)
    const [date, setDate] = useState('')
    const [type, setType] = useState(1)
    const [referent, setReferent] = useState('')
    const [counter, setCounter] = useState('')
    const history = useHistory();
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const handleCloseAlert = () => setShowAlert(false);
    const handleDownload = async (item) => {
      try {
        const path = item?.facture?.replace(/^\/api/, '') || ''
        const response = await apiClient().get(path, {
          params: { api_token: user.api_token, token: user.api_token },
          responseType: 'blob'
        })
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = blobUrl
        link.setAttribute('download', `facture_${item.id}.pdf`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(blobUrl)
      } catch (e) {
        console.log('download error', e)
      }
    }
    const label = { inputProps: { 'aria-label': '' } };
    const [abonnement, setAbonnement] = useState({});
    const [reservations, setreservations] = useState([]);

    // États pour le système de codes de réduction
    const [discountCode, setDiscountCode] = useState('');
    const [currentDiscount, setCurrentDiscount] = useState(null);
    const [discountCodeInput, setDiscountCodeInput] = useState('');
    const [discountLoading, setDiscountLoading] = useState(false);
    const [discountMessage, setDiscountMessage] = useState('');
    const [discountMessageType, setDiscountMessageType] = useState(''); // 'success' ou 'error'

    useEffect(() => {
        getAbonnement();
        getCurrentDiscountCode();
    }, []);

    useEffect(() => {

    }, []);

    function getAbonnement() {
        let params = {
            token:user.api_token,
            api_token:user.api_token,
        }

        apiClient().post(`/get/abonnement`, params)
        .then((res) => {
            if (res.data.success=='ok') {
                setAbonnement(res.data.abonnement)
                setreservations(res.data.reservations)

                if(res.data.referent){
                    setReferent(res.data.referent)
                }
            }
        })
    }

    // Récupérer le code de réduction actuel
    function getCurrentDiscountCode() {
        const params = {
            token: user.api_token,
            api_token: user.api_token,
        };

        apiClient().get('/discount-codes/current', { 
            headers: { 'Authorization': `Bearer ${user.api_token}` }
        })
        .then((res) => {
            if (res.data.success === 'ok') {
                if (res.data.data.has_code) {
                    setCurrentDiscount(res.data.data.data);
                }
            }
        })
        .catch((error) => {
            console.log('Erreur lors de la récupération du code actuel:', error);
        });
    }

    // Assigner un nouveau code de réduction
    function assignDiscountCode() {
        if (!discountCodeInput.trim()) {
            showDiscountMessage(t('subscription.enter_code_required'), 'error');
            return;
        }

        setDiscountLoading(true);
        const params = {
            code: discountCodeInput.trim(),
            token: user.api_token,
            api_token: user.api_token,
        };

        apiClient().post('/discount-codes/assign', params, {
            headers: { 'Authorization': `Bearer ${user.api_token}` }
        })
        .then((res) => {
            setDiscountLoading(false);
            
            if (res.data.success === 'ok') {
                setCurrentDiscount(res.data.data);
                setDiscountCodeInput('');
                showDiscountMessage(res.data.message, 'success');
            } else {
                showDiscountMessage(res.data.message || 'Code invalide.', 'error');
            }
        })
        .catch((error) => {
            setDiscountLoading(false);
            showDiscountMessage(t('subscription.code_validation_error'), 'error');
        });
    }

    // Supprimer le code de réduction actuel
    function removeDiscountCode() {
        setDiscountLoading(true);
        
        apiClient().delete('/discount-codes/remove', {
            headers: { 'Authorization': `Bearer ${user.api_token}` }
        })
        .then((res) => {
            setDiscountLoading(false);
            
            if (res.data.success === 'ok') {
                setCurrentDiscount(null);
                showDiscountMessage(res.data.message, 'success');
            } else {
                showDiscountMessage(res.data.message || 'Erreur lors de la suppression.', 'error');
            }
        })
        .catch((error) => {
            setDiscountLoading(false);
            showDiscountMessage(t('subscription.code_removal_error'), 'error');
        });
    }

    // Afficher un message temporaire
    function showDiscountMessage(message, type) {
        setDiscountMessage(message);
        setDiscountMessageType(type);
        
        setTimeout(() => {
            setDiscountMessage('');
            setDiscountMessageType('');
        }, 5000);
    }

    // Fonction pour calculer le prix avec réduction
    const calculateDiscountedPrice = (originalPrice, discountData) => {
        if (!discountData || !discountData.is_valid) {
            return {
                original: originalPrice,
                discounted: originalPrice,
                hasDiscount: false,
                savings: 0,
                percentage: 0
            };
        }

        const percentage = discountData.reduction_percentage;
        const savings = originalPrice * (percentage / 100);
        const discountedPrice = originalPrice - savings;

        return {
            original: originalPrice,
            discounted: discountedPrice,
            hasDiscount: true,
            savings: savings,
            percentage: percentage
        };
    };

    // Fonction pour obtenir les détails de prix à afficher
    const getPriceDetails = () => {
        if (!abonnement?.formule?.price) return null;
        
        const originalPrice = parseFloat(abonnement.formule.price);
        return calculateDiscountedPrice(originalPrice, currentDiscount);
    };

    const PriceDisplay = () => {
        const priceDetails = getPriceDetails();
        
        if (!priceDetails) return null;

        return (
            <div className='pricebox'>
                <h3>{getTranslation(abonnement?.formule?.titre, i18n.language)}</h3>
                
                {priceDetails.hasDiscount ? (
                    <div className="price-with-discount">
                        <h4 className="original-price">
                            <span style={{textDecoration: 'line-through', color: '#FF914D', fontSize: '0.8em'}}>
                                {priceDetails.original.toFixed(2)}€
                            </span>
                        </h4>
                        <h4 className="discounted-price" style={{color: '#43c3cc'}}>
                            {priceDetails.discounted.toFixed(2)}€
                            <span><sup>{t('subscription.per_session')}</sup></span>
                        </h4>
                        <div style={{textAlign: 'center'}}>
                            <div className="savings-badge" style={{
                                background: '#28a745', 
                                color: 'white', 
                                padding: '4px 8px', 
                                borderRadius: '4px', 
                                fontSize: '0.8em',
                                marginTop: '5px',
                                display: 'inline-block'
                            }}>
                                -{priceDetails.percentage}% • {t('subscription.savings')}: {priceDetails.savings.toFixed(2)}€
                            </div>
                        </div>
                    </div>
                ) : (
                    <h4>{priceDetails.original.toFixed(2)}€<span><sup>{t('subscription.per_session')}</sup></span></h4>
                )}
                
                <div className="pricebox-border2"></div>

                <div className='ttcontent'>
                    <ul className='col-9028-K'>
                        <li><i className='fa fa-check-circle icochecked'></i> {abonnement?.formule?.temps} min</li>
                    </ul>

                    <label>{t('common.description')}</label>
                    <p>{getTranslation(abonnement?.formule?.contenu, i18n.language)}</p>
                </div>
            </div>
        );
    };

    const updatepraticien = () => {
        let params = {'tarif':abonnement?.tarif, 'formule':abonnement?.formule}
        dispatch({ type: SET_FORMULE_UPDATE, payload: params })
        history.push('/list-psychologue/?p=true');
    }

    return (
        <div className="mescommandes register abonnement  bg778635 " >

            <Container>
                <Row>
                    <Col  className="text-center mx-auto my-5"  lg="3">
                        <Menu slug='abonnement' />
                    </Col>

                    <Col  className="text-center mx-auto my-5 menudashright"  >
                        <h3 className="mb-4" >{t('subscription.title')}</h3>

                        <div className='contentsection'>

                            {
                                abonnement?.formule &&
                                <div className='flexrowtarifs row' style={{    textAlign: 'left'}}>
                                    <div className=' col-md-12'>
                                        <div className="text-center flowpriceheader"><img src={abonnement?.tarif?.image}/><h2>{getTranslation(abonnement?.tarif?.titre, i18n.language)}</h2></div>
                                    </div>

                                    <div className='item col-md-6'>
                                        <PriceDisplay />
                                    </div>
                                </div>
                            }

                            {
                                !referent &&
                                <div>
                                    <div style={{width:'100%',borderTop:'1px solid #ccc', paddingTop:'10px', marginTop:'30px'}} ></div>

                                    {
                                        abonnement?.formule &&
                                        <div className="flexitems alert alert-primary" >
                                            <a href="javascript:void(0)" onClick={()=>updatepraticien()} class="btnlink marauto btnlinkjaun">{t('subscription.change_therapist')} </a>
                                        </div>
                                    }
                                </div>
                            }

                            {/* NOUVEAU : Encart Code de Réduction */}
                            <div className="discount-code-section">
                                <div style={{width:'100%',borderTop:'1px solid #ccc', paddingTop:'20px', marginTop:'20px'}}></div>
                                
                                <div className="discount-code-container">
                                    <h4 className="discount-title">
                                        <i className="fa fa-percent"></i> {t('subscription.company_discount_title')}
                                    </h4>
                                    
                                    {/* Message d'information */}
                                    {discountMessage && (
                                        <div className={`alert ${discountMessageType === 'success' ? 'alert-success' : 'alert-danger'} discount-message`}>
                                            {discountMessage}
                                        </div>
                                    )}

                                    {/* Affichage du code actuel */}
                                    {currentDiscount ? (
                                        <div className="current-discount-card">
                                            <div className="discount-card-header">
                                                <h5>
                                                    <i className="fa fa-check-circle text-success"></i>
                                                    {t('subscription.active_code_label')} <strong>{currentDiscount.code}</strong>
                                                </h5>
                                            </div>
                                            <div className="discount-card-body">
                                                <div className="row">
                                                    <div className="col-md-8">
                                                        <p className="enterprise-info">
                                                            <strong>{t('subscription.enterprise_label')}</strong> {currentDiscount.entreprise.nom}
                                                        </p>
                                                        <p className="reduction-info">
                                                            <strong>{t('subscription.discount_label')}</strong> 
                                                            <span className="reduction-badge">{currentDiscount.reduction_formattee}</span>
                                                        </p>
                                                        {currentDiscount.expires_at_human !== 'Pas d\'expiration' && (
                                                            <p className="expiry-info">
                                                                <strong>{t('subscription.expiry_label')}</strong> {currentDiscount.expires_at_human}
                                                            </p>
                                                        )}
                                                    </div>
                                                    <div className="col-md-4 text-right">
                                                        <Button 
                                                            variant="outline-danger" 
                                                            size="sm" 
                                                            onClick={removeDiscountCode}
                                                            disabled={discountLoading}
                                                            className="remove-code-btn"
                                                        >
                                                            {discountLoading ? (
                                                                <><i className="fa fa-spinner fa-spin"></i> {t('subscription.deleting')}</>
                                                            ) : (
                                                                <><i className="fa fa-trash"></i> {t('common.remove')}</>
                                                            )}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        /* Formulaire pour ajouter un code */
                                        <div className="add-discount-form">
                                            <p className="form-description">
                                                {t('subscription.discount_code_info')}
                                            </p>
                                            <div className="input-group">
                                                <Form.Control
                                                    type="text"
                                                    placeholder={t('subscription.discount_code_placeholder')}
                                                    value={discountCodeInput}
                                                    onChange={(e) => setDiscountCodeInput(e.target.value.toUpperCase())}
                                                    disabled={discountLoading}
                                                    className="discount-input"
                                                    onKeyPress={(e) => e.key === 'Enter' && assignDiscountCode()}
                                                />
                                                <div className="input-group-append">
                                                    <Button 
                                                        variant="primary" 
                                                        onClick={assignDiscountCode}
                                                        disabled={discountLoading || !discountCodeInput.trim()}
                                                        className="apply-code-btn"
                                                    >
                                                        {discountLoading ? (
                                                            <><i className="fa fa-spinner fa-spin"></i> {t('subscription.validating')}</>
                                                        ) : (
                                                            <><i className="fa fa-check"></i> {t('common.apply')}</>
                                                        )}
                                                    </Button>
                                                </div>
                                            </div>
                                            <small className="form-text text-muted">
                                                {t('subscription.code_partner_hint')}
                                            </small>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <br/>

                            {
                                abonnement?.therapeute &&
                                <Accordion >
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>{t('subscription.referent_therapist')}</Accordion.Header>
                                        <Accordion.Body>
                                            {
                                                referent!=='' &&
                                                <Row className="mb-3"  >
                                                    <div className='itemimg col-md-3' style={{backgroundImage:referent?.picture ? `url(${BASE_URL_PROD + "gestion/public/uploads/"+referent?.picture})` : "url('/images/default-profile.png')"}}></div>
                                                    <h3>{referent?.name}</h3>
                                                    <br/>
                                                    <div>
                                                        <div class="flexitems"><a href="javascript:void(0)" class="btnlink marauto" onClick={()=>history.push('/messages?p='+referent?.user_id)} >{t('appointment.contact_therapist')}   </a><a href="javascript:void(0)" onClick={()=>history.push('/profil-therapeute/'+referent?.name+'/'+referent?.user_id)} class="btnlink marauto btnlinkjaun">{t('therapist.view_profile')}   </a></div>
                                                    </div>
                                                </Row>
                                            }
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            }

                            <br/>
                            <Accordion >
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>{t('subscription.consultation_history')}</Accordion.Header>
                                    <Accordion.Body>
                                        <Row className="mb-3"  >
                                            <div className='tavbleweb'>
                                                <Table responsive  >
                                                    <thead>
                                                        <tr>
                                                            <th key="0">{t('common.col_need')}</th>
                                                            <th key="1">{t('common.col_formula')}</th>
                                                            <th key="2">{t('common.col_date')}</th>
                                                            <th key="3" >{t('common.col_price')}</th>
                                                            <th key="4">{t('common.col_therapist')}</th>
                                                            <th key="5">{t('common.col_status')}</th>
                                                            <th key="6" >{t('common.col_actions')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            reservations.map((item,i)=>(
                                                                <tr>
                                                                    <td>{getTranslation(item.tarif?.titre, i18n.language)}</td>
                                                                    <td>{getTranslation(item.formule?.titre, i18n.language)}</td>
                                                                    <td>{moment(item?.date_rdv).format("DD/MM/YYYY")} {item?.heure_rdv_patient}</td>
                                                                    <td>{parseFloat(item?.formule?.price).toFixed(2)}€</td>
                                                                    <td><a href='#'>{item?.therapeute?.name}</a></td>
                                                                    <td>
                                                                        {item.status==2 && <div className="badge alert-success">{t('common.status_completed')}</div>}
                                                                        {item.status==3 && <div className="badge alert-danger">{t('common.status_cancelled')}</div>}
                                                                        {item.status==4 && <div className="badge alert-danger">{t('common.status_moved')}</div>}
                                                                    </td>
                                                                    <td>
                                                                        <div className="list-contr">
                                                                            {
                                                                                item.facture &&
                                                                                <a  href="javascript:void(0)" onClick={() => handleDownload(item)} className="color-bg tolt center view" data-microtip-position="left" data-tooltip="Voir">{t('common.invoice')} <i class="fa fa-file-pdf-o"></i></a>
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>

                            <br/>
                        </div>
                    </Col>
                </Row>

                <Modal show={showAlert} onHide={handleCloseAlert} centered>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        {alertMessage}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseAlert} style={{background: '#000'}}>
                            {t('common.close')}
                        </Button>
                    </Modal.Footer>
                </Modal>

            </Container>
        </div>
    );
}

export default Page;